export default __webpack_public_path__ + "static/media/report.cce9c195.svg";